import React from "react";
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

import { Container, NavbarBrand, Navbar, Nav, NavItem, NavbarToggler, Collapse, Row, Col, Card, Button } from 'reactstrap';

import fee from '../../assets/images/contents/fee.png';

function Payment() {
    return (
      <div className="container max-w-8xl relative mx-auto">
        <Helmet>
          <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - FeePayment</title>
        </Helmet>
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item "><Link to="/scds2023/">Information</Link></li>
            <li class="breadcrumb-item active" aria-current="page">Fee&Payment</li>
          </ol>
        </nav>
          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
                  <H2 color="dark">Fee and Payment</H2>                
              </div>
              <div style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
                <NavbarBrand style={{  justifyContent: "center", alignItems: "center", display: "flex",}}><img src={fee} alt="wrapkit" height= "260px" width= "500px"/></NavbarBrand>
                <p>
                    Fees are inclusive of the following: <br/>
                    1.	Conference registration <br/>
                    2.	Publication of works in proceedings scds2023<br/>
                </p>

                <p>
                <b><u>PAYMENT BY WIRE TRANSFER/CHEQUE</u></b><br/>

                    Bank Account name: UNIVERSITI TEKNOLOGI MARA <br/>
                    Bank Account No: 12177010005662 <br/>
                    Bank Name: Bank Islam Malaysia Berhad <br/>
                    Bank Address : Ground Floor, Bangunan Prima Siswa, Universiti Teknologi MARA <br/>
                    City: Shah Alam <br/>
                    State: Selangor <br/>
                    Country: Malaysia <br/>
                    Swift Code: BIMBMYKL <br/> <br/>

                    After performing the payment, please email a copy of the transaction to us at nurbaizura@tmsk.uitm.edu.my and scds2023@uitm.edu.my 
                    for record management. <br/> 

                    All bank charges are to be borne by the participant. <br/> 

                    Payments made are <b>NOT</b> refundable <br/>

                </p>
            </div>
        </div>
    </div>
    );
}

export default Payment;